import { useContext } from "react";
import { ComparisonDialogContext } from "~/features/compareProducts/context/ComparisonDialogContext";

export const useComparisonDialog = () => {
  const context = useContext(ComparisonDialogContext);

  if (!context) {
    throw new Error("useComparisonDialog must be used inside ComparisonDialogProvider");
  }

  return context;
};
